// extracted by mini-css-extract-plugin
export default {"labelRoot":"Label_labelRoot__E8WFM","overflowEllipsis":"Label_overflowEllipsis__jhNoD","isInteractive":"Label_isInteractive__Y831D"};